$(document).ready(function () {

  $('.cookie-banner-content p').html(`We use cookies to offer you a better browsing experience, analyze site traffic, personalize content and serve targeted advertisements. To learn more or change your cookie preferences, choose <em>Manage Cookie Preferences</em>. For further information on the use of cookies and information we collect, visit our <a href="https://www.asmglobal.com/p/other/privacy-policy" target="_blank">Privacy Policy</a>.`);

  // General Message
  $('.generalmessage').prependTo('header');

  // Searchbox placeholder
  $('.header .searchBox input').attr('placeholder', 'Search Website');

  // create footer nav links
  function getNavLinks() {
    const headerNav = $('#mainNavigation .group');
    const allLinks = [];

    headerNav.each(function () {
      const topLink = $(this);
      const items = topLink.find('.items');
      const topLinkURL = topLink.find('a').first().attr('href');
      const topLinkText = topLink.find('a').first().text();
      let itemsLinks = [];

      if (items) {
        items.find('> .item:not(.navClonedItem)').each(function () {
          const subLink = $(this);
          const subLinkURL = subLink.find('a').first().attr('href');
          const subLinkText = subLink.find('a').first().text();

          itemsLinks.push({
            subLevelLink: subLinkText,
            subLevelURL: subLinkURL
          });
        });
      } else {
        itemsLinks = null;
      }

      allLinks.push({
        topLevelLink: topLinkText,
        topLevelURL: topLinkURL,
        items: itemsLinks
      });
    });

    // console.log(allLinks)
    return allLinks;
  }

  function createFooterNav() {
    const navLinks = getNavLinks();

    const navColumns = navLinks.map((link) => {

      const sublinks = link.items.map((subitem) => {
        return `
          <li>
            <a href="${subitem.subLevelURL}">${subitem.subLevelLink}</a>
          </li>
        `;
      });

      return `
        <div class="custom-footer-nav__col">
          <a href="${link.topLevelURL}" class="custom-footer-nav__toplink">${link.topLevelLink}</a>
          <ul class="custom-footer-nav__sublinks">
              ${sublinks.join('')}
          </ul>
        </div>
      `;
    });

    $('.custom-footer-nav').html(navColumns.join(''));
  }

  createFooterNav();


  // move social icons in footer
  $('.socialNetworks').appendTo('.footer-social');

});
